import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class Router extends Component {
  constructor(props) {
    super(props);
    this.routeTo = this.routeTo.bind(this);
    this.getCurrentComponent = this.getCurrentComponent.bind(this);
    this.state = {
      route: props.defaultRoute,
    };
  }
  routeTo(route) {
    if (route === '/exit') {
      this.props.exitCallback();
    }
    window.scrollTo(0, 0);
    this.setState({
      route: route,
    });
  }
  getCurrentComponent() {
    let element;
    const { children } = this.props;
    React.Children.forEach(children, (child) => {
      if (React.isValidElement(child) && child.props.path === this.state.route) {
        element = React.cloneElement(child, { ...child.props, routeTo: this.routeTo });
      }
    });
    return element;
  }

  render() {
    return <div>{this.getCurrentComponent()}</div>;
  }
}

Router.propTypes = {
  children: PropTypes.array,
  defaultRoute: PropTypes.string,
  exitCallback: PropTypes.func,
};

export { default as Route } from './route';
